export class HeaderData {
    breadcrumb: Array<Breadcrumbs> = null;
    pageTitle: string = "";
    subTitle: string = "";
    detailMenu: Array<DetailMenu>= null;
    detailMenuParentClass?: string = "";
    detailMenuClass?: string = "";
}

export class Breadcrumbs{
    itemName: string = "";
    itemLink: string = "";
}

export class DetailMenu{
    label: string = "";
    labelClass?: string = "";
    description: string = "";
    descClass?: string = "";
    listItemClass?: string = "";
    needFilter?: boolean = true;
}